import { useQuery } from '@tanstack/react-query'

import { UsersService } from '../lib/users.service'

const INVITES_PERMISSIONS_QUERY_KEY = 'invites-permissions'

export const useInvitesPermissions = () => {
  const { data, isLoading } = useQuery({
    queryKey: [INVITES_PERMISSIONS_QUERY_KEY],
    queryFn: () => UsersService.getInvitesPermissions(),
    select: data => data.data
  })

  return { data, isLoading }
}
